import { Item } from '@root/src/types';
import { getVariantsOfBundle } from '@root/src/utils/utils';
import { PromotionalPricingForBundle, PromotionalPricingForProduct } from 'contexts/AppContext';

type ItemPriceProps = {
  price: string;
  discountedPrice?: string | null;
};

export const ItemPrice = ({ price, discountedPrice }: ItemPriceProps) => {
  if (!discountedPrice) {
    return <span className="base-price--no-discount">${price}</span>;
  }

  return (
    <span>
      <s className="base-price--discounted">${price}</s> <span className="discounted-price">${discountedPrice}</span>
    </span>
  );
};

type ProductPriceProps = {
  product: Item;
  promotionalPricing: PromotionalPricingForProduct | null;
};

export const ProductPrice = ({ product, promotionalPricing }: ProductPriceProps) => {
  const basePrice = product.cost!;
  const discountedPrice = promotionalPricing?.value;

  return (
    <span className="text-md">
      <ItemPrice price={basePrice} discountedPrice={discountedPrice} />
    </span>
  );
};

type BundlePriceProps = {
  bundle: Item;
  promotionalPricing: PromotionalPricingForBundle | null;
};

export const BundlePrice = ({ bundle, promotionalPricing }: BundlePriceProps) => {
  const { rentalBundle, retailBundle } = getVariantsOfBundle(bundle);

  const showRentalPrice = !!rentalBundle;
  const showRetailPrice = !!retailBundle;

  const baseRentalPrice = rentalBundle?.cost ?? '';
  const baseRetailPrice = retailBundle?.cost ?? '';

  const discountedRentalPrice = promotionalPricing?.rentalValue;
  const discountedRetailPrice = promotionalPricing?.retailValue;

  const hasDiscountForBoth = !!discountedRentalPrice && !!discountedRetailPrice;

  return (
    <span className={`${hasDiscountForBoth ? 'text-[12px] sm:text-[15px]' : 'text-[14px]'} md:text-md`}>
      {showRentalPrice && (
        <>
          Rent <ItemPrice price={baseRentalPrice} discountedPrice={discountedRentalPrice} />
        </>
      )}

      {showRentalPrice && showRetailPrice && ' / '}

      {showRetailPrice && (
        <>
          Buy <ItemPrice price={baseRetailPrice} discountedPrice={discountedRetailPrice} />
        </>
      )}
    </span>
  );
};
